<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div
	[ngClass]="['ag-overlay-loading-center', 'no-data-table']"
	role="presentation"
>
	<span class="icon-warning-hex"></span>

	<span class="message">No data available</span>
</div>
